import { AlertTriangle, ArrowUpRight, Briefcase, ShieldAlert } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card'
import type { HandoverCounts } from '../types'

interface Props {
  counts: HandoverCounts
}

const STATS: {
  key: keyof HandoverCounts
  label: string
  icon: React.ComponentType<{ size?: number; className?: string }>
  tone: string
}[] = [
  { key: 'open_cases_count', label: 'Open cases', icon: Briefcase, tone: 'text-fg' },
  { key: 'open_alerts_count', label: 'Open alerts', icon: ShieldAlert, tone: 'text-fg' },
  { key: 'critical_items_count', label: 'Critical', icon: AlertTriangle, tone: 'text-status-failed' },
  { key: 'sla_at_risk_count', label: 'SLA at risk', icon: ArrowUpRight, tone: 'text-status-pending' },
]

/**
 * AF-135 — auto-populated counts card. Numbers come from the backend
 * shift-summary endpoint; analysts can't edit them but they're visible
 * on every handover view (form + acknowledge + log) for context.
 */
export function CountsCard({ counts }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>State of the queue</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="grid grid-cols-2 gap-3 md:grid-cols-4">
          {STATS.map((s) => {
            const Icon = s.icon
            return (
              <div key={s.key} className="rounded border border-border bg-card p-3">
                <dt className="flex items-center gap-1.5 text-[0.625rem] uppercase tracking-wide text-muted-fg">
                  <Icon size={12} aria-hidden /> {s.label}
                </dt>
                <dd className={'mt-1 font-mono text-2xl font-semibold tabular-nums ' + s.tone}>
                  {counts[s.key]}
                </dd>
              </div>
            )
          })}
        </dl>
      </CardContent>
    </Card>
  )
}
